import React from 'react'
import { useTranslation } from '@mc/i18n'
import { SessionFeaturedProjects } from '@mc/api'

import { Gallery } from 'pages/sessions/shared/Gallery'

export const FeaturedProjects = ({
  projects,
}: {
  projects?: SessionFeaturedProjects[]
}) => {
  const { t } = useTranslation('@mc/next')

  return (
    <>
      <div className='row no-gutters justify-content-center'>
        <div className='col-12 col-lg-10'>
          <h2 className='mc-text-h1 mc-mb-10 mc-text--center'>
            {t('sessions.featuredProjects.header')}
          </h2>
        </div>
      </div>
      <div className='d-flex flex-column align-items-center'>
        <Gallery projects={projects} />
      </div>
    </>
  )
}
